import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import {computed, getCurrentInstance, onMounted, onUnmounted, ref, watch} from 'vue';
import {WidgetStore} from "~/chat/ts/store/Widget";
import ChatModalHelper from "~/chat/vue/widget/ChatModalHelper";
import ConsoleWrapper from "~/ts/library/Console";
import {Timeouts} from "~/ts/library/delay/Timeouts";
import {addDisposableEvent} from "~/ts/vuePlugins/useDisposableEvent";


const __default__ = {
    name: "ChatModal"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    visible: { type: Boolean, default: true },
    closeByOverlay: { type: Boolean, default: true },
    appendToBody: { type: Boolean }
  },
  emits: ["update:visible"],
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit;

let isMountDone = ref(false);
let visibleTime = 0;

function setVisibleTime() {
    if (props.visible) {
        visibleTime = Date.now();
    }
}

setVisibleTime();

watch(computed(() => props.visible), () => setVisibleTime())

let instance = getCurrentInstance().proxy;

let isAppendToBodyComputed = computed(() => {
    let result = props.appendToBody;
    if (!result) {
        result = ChatModalHelper.isMustToBeInBody(instance.$el as HTMLElement);
    }
    return result;
});

function getParentElement() {
    return document.getElementById(isAppendToBodyComputed.value ? WidgetStore.widgetRootContainerId.value : WidgetStore.widgetInnerContainerId.value);
}

function close() {
    emits("update:visible", false);
}

function onOverlayClick() {
    if (props.closeByOverlay) {
        if (Date.now() - visibleTime > 300) {
            close();
        }
    }
}

onMounted(() => {
    appendChildToParent();
});

function appendChildToParent() {
    let parent = getParentElement();
    if (parent) {
        parent.appendChild(instance.$el);
        isMountDone.value = true;
    } else {
        ConsoleWrapper.warn("Parent not found");
        addDisposableEvent(Timeouts.setDisposable(() => {
            appendChildToParent();
        }, 100));
    }

}

onUnmounted(() => {
    let parent = instance.$el.parentElement;
    if (parent) {
        let $el = instance.$el;
        setTimeout(() => {
            parent = instance.$el.parentElement;
            if (parent) {
                parent.removeChild($el);
            }
        }, 200);
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "chat-modal" }, {
    default: _withCtx(() => [
      (_ctx.visible && _unref(isMountDone))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(['modal-wrapper overlay absolute-full-size d-flex align-items-center', _unref(isAppendToBodyComputed) ? 'append-to-body' : null]),
            onClick: _withModifiers(onOverlayClick, ["exact"])
          }, [
            _renderSlot(_ctx.$slots, "default")
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}
}

})